import React, { useId } from 'react';
import styles from '../Input/Input.module.css';

const clsx = (...args) => args.filter(Boolean).join(' ');

const Textarea = React.forwardRef(function Textarea(
  { label, helpText, error, tone = 'light', id, rows = 4, className, ...rest },
  ref
) {
  const errorId = useId();
  const wrapCls = clsx(
    styles.wrap,
    tone === 'dark' && styles.onDark,
    error && styles.error
  );

  return (
    <div className={wrapCls}>
      {label && (
        <label className={styles.label} htmlFor={id}>
          {label}
        </label>
      )}
      <textarea
        ref={ref}
        id={id}
        rows={rows}
        className={clsx(styles.field, styles.textarea, className)}
        aria-invalid={!!error}
        aria-describedby={error ? errorId : undefined}
        {...rest}
      />
      {(helpText || error) && (
        <span className={styles.helpText} id={error ? errorId : undefined}>
          {error || helpText}
        </span>
      )}
    </div>
  );
});

export default Textarea;
